import type { Instance, Unit } from "@/api/client";

export type ReviewState = "proposed" | "accepted" | "rejected" | "relabelled";

/** What the estimator's latest decision makes of an instance. */
export function reviewState(instance: Instance): ReviewState {
  const decision = instance.latest_decision?.decision;
  if (decision === "accept") {
    return "accepted";
  }
  if (decision === "reject") {
    return "rejected";
  }
  if (decision === "relabel") {
    return "relabelled";
  }
  return "proposed";
}

/** "→ W-02" or "→ section": where a relabel points. */
export function relabelTarget(instance: Instance, units: readonly Unit[]): string | null {
  const decision = instance.latest_decision;
  if (!decision || decision.decision !== "relabel") {
    return null;
  }
  if (decision.corrected_unit_id) {
    const unit = units.find((u) => u.id === decision.corrected_unit_id);
    return unit ? unit.mark : "another unit";
  }
  return decision.corrected_view_type ?? null;
}

export const STATE_LABEL: Record<ReviewState, string> = {
  proposed: "Proposed",
  accepted: "Accepted",
  rejected: "Rejected",
  relabelled: "Relabelled",
};
